module.exports = __webpack_public_path__ + "static/media/firebase.83422e98.png";